export const after_Carousel_images = [
  "https://images-static.nykaa.com/uploads/fad4269e-a68e-4eca-9244-da27880090c7.jpg?tr=w-1200,cm-pad_resize",
  "https://images-static.nykaa.com/uploads/034c8d31-94c7-47bb-b474-e2af8d7f5244.jpg?tr=w-1200,cm-pad_resize",
];
